import { useEffect, useRef, useState } from 'react';
import PageTitle from '../../components/PageTitle';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ScriptSureIframeLayout from '../../components/ScriptSure/ScriptSureIframeLayout';
import { OrderResponse, OrderStatusEnum } from '../../models/PatientModels';
import { useUpdateOrderStatusMutation } from '../../features/patient/patientService';
import ConfirmationModal from '../../components/Orders/ConfirmationModal';

const ApproveMedications = () => {
    const navigate = useNavigate();
    const { id: patientId = '', medicationId, orderId } = useParams();
    const [getHelpModalOpen, setGetHelpModalOpen] = useState<boolean>(false);

    // The idea is to have approve medications be in a list regardless of it being a single or batch submit
    // If it is a single submit, then the list will only contain a single item
    // Works this way to ensure the same iframe closure logic for both scenarios
    const removeFromOrderQueue = () => {
        let data: OrderResponse[] = JSON.parse(localStorage.getItem('allMedications') as string);
        
        const newData: OrderResponse[] = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].id === orderId) {
                continue;
            }

            newData.push(data[i]);
        }
        
        // If no medications left to submit, then close the page and go back
        // Else load the next one
        if (newData.length === 0) {
            localStorage.removeItem('allMedications');
            navigate(`/patient/${patientId}/approve-medications/submitAll`);
        }
        else {
            localStorage.setItem(
                'allMedications',
                JSON.stringify(newData),
            );

            data = JSON.parse(localStorage.getItem('allMedications') as string);

            navigate(
                `/patient/${patientId}/add-approve-medication/${data[0].scriptSureOrderId}/${data[0].id}`,
            );
        }

        
    }

    return (
        <div>
            <PageTitle
                title="Review Medications"
                onClick={() => {
                    localStorage.removeItem('allMedications');
                    navigate(
                        `/patient/${patientId}/approve-medications/submitAll`,
                    );
                }}
            >
                <div className="get-help">
                    <button
                        type="button"
                        style={{ backgroundColor: 'rgb(33,150,243)' }}
                        className="btn btn-primary btn-sm"
                        onClick={() => setGetHelpModalOpen(true)}
                    >
                        Get Help
                    </button>
                </div>
            </PageTitle>
            <ScriptSureIframeLayout
                scriptSureSource={(
                    webAppUrl: string,
                    scriptSurePatientId: number,
                    scriptSureSessionToken: string,
                ) =>
                    `${webAppUrl}/widgets/prescription/${scriptSurePatientId}/${medicationId}?sessiontoken=${scriptSureSessionToken}&darkmode=off`
                }
                getHelpModalOpen={getHelpModalOpen}
                setGetHelpModalOpen={setGetHelpModalOpen}
                triggerFunction={() => removeFromOrderQueue()}
            />
        </div>
    );
};

export default ApproveMedications;
